import Autocomplete from './Autocomplete';
import type { IAutocompleteProps } from './Autocomplete.types';

export default Autocomplete;
export { IAutocompleteProps };
